// TWO types (P5/P8 FINAL 8 Aug): sickness is a REASON under CL, not a type.
// The apply form fetches this list from GET /leaves/meta — these constants
// remain only for filters/labels on list pages until Block 2's promotion
// sweep, and the backend contract test pins them to the validator.
export const LEAVE_TYPES = [
  { value: "CL", label: "Casual Leave (CL)", short: "CL" },
  { value: "PL", label: "Privilege Leave (PL)", short: "PL" },
];

export const HALF_DAY_OPTIONS = [
  { value: "", label: "Full day" },
  { value: "first_half", label: "First half" },
  { value: "second_half", label: "Second half" },
];

export const STATUS_OPTIONS = [
  { value: "pending", label: "Pending" },
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
  { value: "cancelled", label: "Cancelled" },
];

export const LEAVE_TYPE_LABEL = {
  CL: "Casual",
  PL: "Privilege",
};




